import { InjectionToken } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

export const TOAST_SERVICE = new InjectionToken<ToastrService>('ToastService');
